import { registerWidget } from "dmeditor";
import definition from "./definition";
import { ClubMembers } from "./ClubMembers";
import { serverImport } from "../../serverImport";

const register = () => {
  registerWidget(definition, {
    render: ClubMembers,
    onServerSideLoad: serverImport(() => import("./onServerSideLoad")),
  });
};

export default register;
